// Función para convertir Hex (#FF0000) a formato Lottie [0.1, 0.5, 1, 1]
const hexToLottieRgba = (hex: string): number[] => {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  return [r, g, b, 1];
};

export const colorizeLottieDynamic = (animationData: any, newColor: string) => {
  const lottieColor = hexToLottieRgba(newColor);
  
  // Clonamos para no mutar el original
  const newAnimationData = JSON.parse(JSON.stringify(animationData));

  // Función recursiva para buscar la propiedad "c" (color) en el JSON
  const findAndReplaceColor = (obj: any) => {
    if (obj && typeof obj === 'object') {
      if (obj.c && obj.v !== undefined) { // Es una propiedad de color animada
         // No hacemos nada o lógica compleja
      } else if (obj.c && Array.isArray(obj.k)) {
        // Encontramos un color (propiedad 'c' con 'k' como valor/keyframe)
        if (typeof obj.k[0] === 'number') {
          obj.k = lottieColor;
        }
      }
      
      // Seguimos buscando en el resto del objeto
      Object.keys(obj).forEach(key => findAndReplaceColor(obj[key]));
    }
  };

  findAndReplaceColor(newAnimationData);
  return newAnimationData;
};